import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, SparklesIcon, PaletteIcon, BookOpenIcon, FlameIcon } from 'lucide-react';
const audiences = [{
  icon: HeartIcon,
  title: 'Amantes de la cultura japonesa',
  desc: 'Para quienes sienten una conexión profunda con la estética, la historia y la filosofía de Japón.'
}, {
  icon: SparklesIcon,
  title: 'Personas que quieren tatuarse',
  desc: 'Para quienes están por dar el paso y quieren elegir un símbolo con conocimiento, no con impulso.'
}, {
  icon: PaletteIcon,
  title: 'Tatuadores y artistas',
  desc: 'Para profesionales que buscan una biblioteca visual completa de referencia y estudio.'
}, {
  icon: BookOpenIcon,
  title: 'Coleccionistas de libros visuales',
  desc: 'Para quienes valoran las obras editoriales bellas, cuidadas y con identidad propia.'
}, {
  icon: FlameIcon,
  title: 'Fans del irezumi',
  desc: 'Para quienes admiran el arte del tatuaje japonés tradicional y quieren conocerlo en profundidad.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-125">
      <div className="max-w-6xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-127">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-128">
            <span className="text-xs font-bold tracking-widest" data-id="element-129">
              🌸 ESTA COLECCIÓN ES PARA VOS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-130">
            ¿Para quién es esta{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-131">
              colección?
            </span>
          </h2>
          <p className="text-ink-soft text-base md:text-lg mt-5 max-w-2xl mx-auto leading-relaxed" data-id="element-132">
            Una biblioteca visual pensada para todos los que viven —o quieren
            vivir— el arte del irezumi.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-133">
          {audiences.map((a, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} whileHover={{
          y: -4
        }} className="bg-bg-soft border border-line rounded-3xl p-6 md:p-7 shadow-sm hover:shadow-xl hover:shadow-rose/10 transition-all flex flex-col" data-id="element-134">
              <div className="flex items-start gap-4 mb-3" data-id="element-135">
                <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-rose/15 flex items-center justify-center" data-id="element-136">
                  <a.icon className="w-6 h-6 text-rose" strokeWidth={2} data-id="element-137" />
                </div>
                <h3 className="font-serif font-bold text-lg md:text-xl text-ink leading-snug uppercase pt-2" data-id="element-138">
                  {a.title}
                </h3>
              </div>
              <p className="text-ink-soft text-sm leading-relaxed" data-id="element-139">{a.desc}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center font-serif-italic text-rose mt-12 text-lg md:text-xl" data-id="element-140">
          Si te identificás con alguno, esta colección fue hecha para vos.
        </motion.p>
      </div>
    </section>;
}